import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

/* Layout */
import LayoutBack from '@/layout/back.vue'

Vue.use(VueRouter)

export const constantRoutes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/index')
  },
  {
    path: '/selectionSys/:channelId',
    name: 'SelectionSys',
    component: () => import(/* webpackChunkName: "SelectionSys" */ '@/views/selectionSystem/index.vue')
  },
  // {
  //   path: '/infoCenter/:channelId/:id',
  //   name: 'InfoCenter',
  //   component: () => import(/* webpackChunkName: "InfoCenter" */ '@/views/infoCenter/index.vue')
  // },
  // {
  //   path: '/infoCenter/:channelId/:id',
  //   name: 'InfoCenter',
  //   component: () => import(/* webpackChunkName: "InfoCenter" */ '@/views/infoCenter/index.vue')
  // },
  {
    path: '/infoCenter',
    name: 'InfoCenter',
    component: () => import(/* webpackChunkName: "InfoCenter" */ '@/views/infoCenter/layout.vue'),
    redirect: '/infoCenter/:channelId/:id',
    children: [
      {
        path: '/infoCenter/:channelId/:id',
        name: 'InfoCenter',
        component: () => import(/* webpackChunkName: "InfoCenter" */ '@/views/infoCenter/index.vue')
      },
      {
        path: '/infoCenter/detail/:channelId/:id',
        name: 'InfoCenterDetail',
        component: () => import(/* webpackChunkName: "InfoCenterDetail" */ '@/views/infoCenter/detail.vue')
      },
    ]
  },
  {
    path: '/dataCenter',
    name: 'DataCenter',
    component: () => import(/* webpackChunkName: "DataCenter" */ '@/views/dataCenter/layout.vue'),
    redirect: '/dataCenter/spotPrice/:channelId/:menuId',
    children: [
      {
        path: 'spotPrice/:channelId/:menuId',
        name: 'SpotPrice',
        component: () => import(/* webpackChunkName: "SpotPrice" */ '@/views/dataCenter/spotPrice.vue')
      },
      {
        path: 'averagePrice/:channelId/:menuId',
        name: 'AveragePrice',
        component: () => import(/* webpackChunkName: "AveragePrice" */ '@/views/dataCenter/averagePrice.vue')
      },
      {
        path: 'chart/:channelId/:menuId',
        name: 'DataCenterChart',
        component: () => import(/* webpackChunkName: "DataCenterChart" */ '@/views/dataCenter/chart.vue')
      },
    ]
  },
  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackChunkName: "News" */ '@/views/news/layout.vue'),
    redirect: '/news/list/:channelId/:menuId',
    children: [
      {
        path: 'list/:channelId/:menuId',
        name: 'NewsList',
        component: () => import(/* webpackChunkName: "NewsList" */ '@/views/news/list.vue')
      },
      {
        path: 'detail/:channelId/:menuId',
        name: 'NewsDetail',
        component: () => import(/* webpackChunkName: "NewsDetail" */ '@/views/news/detail.vue')
      },
      {
        path: 'contentDetail/:channelId/:menuId',
        name: 'NewsContentDetail',
        component: () => import(/* webpackChunkName: "NewsContentDetail" */ '@/views/news/contentDetail.vue')
      },
    ]
  },
  {
    path: '/shopGuide',
    name: 'ShopGuide',
    component: () => import(/* webpackChunkName: "ShopGuide" */ '@/views/shoppingGuide/layout.vue'),
    redirect: '/shopGuide/tradeRules',
    children: [
      {
        path: 'tradeRules/:channelId/:menuId',
        name: 'TradeRules',
        component: () => import(/* webpackChunkName: "TradeRules" */ '@/views/shoppingGuide/tradeRules.vue')
      },
      {
        path: 'tradeRulesDetail/:channelId/:menuId',
        name: 'TradeRulesDetail',
        component: () => import(/* webpackChunkName: "TradeRulesDetail" */ '@/views/shoppingGuide/tradeRulesDetail.vue')
      },
      {
        path: 'warehouse/:channelId/:menuId',
        name: 'Warehouse',
        component: () => import(/* webpackChunkName: "Warehouse" */ '@/views/shoppingGuide/warehouse.vue')
      },
      {
        path: 'deliveryData/:channelId/:menuId',
        name: 'DeliveryData',
        component: () => import(/* webpackChunkName: "DeliveryData" */ '@/views/shoppingGuide/deliveryData.vue')
      },
      {
        path: 'freeInspection',
        name: 'FreeInspection',
        component: () => import(/* webpackChunkName: "FreeInspection" */ '@/views/shoppingGuide/freeInspection.vue')
      },
      {
        path: 'serviceTime',
        name: 'ServiceTime',
        component: () => import(/* webpackChunkName: "ServiceTime" */ '@/views/shoppingGuide/serviceTime.vue')
      },
    ]
  },
  {
    path: '/userCenter',
    name: 'UserCenter',
    component: () => import(/* webpackChunkName: "UserCenter" */ '@/views/userCenter/layout.vue'),
    redirect: '/userCenter/index',
    children: [
      {
        path: 'index',
        name: 'UserCenterIndex',
        component: () => import(/* webpackChunkName: "UserCenterIndex" */ '@/views/userCenter/index.vue')
      },
      {
        path: 'notice/:menuId',
        name: 'UserCenterNotice',
        component: () => import(/* webpackChunkName: "UserCenterNotice" */ '@/views/userCenter/notice.vue')
      },
      {
        path: 'noticeDetail/:menuId',
        name: 'UserCenterNoticeDetail',
        component: () => import(/* webpackChunkName: "UserCenterNoticeDetail" */ '@/views/userCenter/noticeDetail.vue')
      },
      {
        path: 'arrange/:menuId',
        name: 'UserCenterArrange',
        component: () => import(/* webpackChunkName: "UserCenterArrange" */ '@/views/userCenter/arrange.vue')
      },
      {
        path: 'download/:menuId',
        name: 'UserCenterDownload',
        component: () => import(/* webpackChunkName: "UserCenterDownload" */ '@/views/userCenter/download.vue')
      },
      {
        path: 'bankSign/:menuId/:subMenuId',
        name: 'UserCenterBankSign',
        component: () => import(/* webpackChunkName: "UserCenterBankSign" */ '@/views/userCenter/bankSign.vue')
      },
      {
        path: 'articleSigle/:menuId',
        name: 'ArticleSigle',
        component: () => import(/* webpackChunkName: "ArticleSigle" */ '@/views/userCenter/articleSigle.vue')
      },
      {
        path: 'basicData',
        name: 'BasicData',
        component: () => import(/* webpackChunkName: "BasicData" */ '@/views/userCenter/basicData.vue')
      },
    ]
  },
  {
    path: '/signLogin',
    name: 'SignLogin',
    component: () => import(/* webpackChunkName: "SignLogin" */ '@/views/sign/login.vue')
  },
  {
    path: '/sign',
    name: 'SignIndex',
    component: () => import(/* webpackChunkName: "SignIndex" */ '@/views/sign/index.vue')
  },
  {
    path: '/personal/auth',
    name: 'PersonalAuth',
    component: () => import(/* webpackChunkName: "PersonalAuth" */ '@/views/sign/personalAuth.vue')
  },
  {
    path: '/personal/authback',
    name: 'PersonalAuthBack',
    component: () => import(/* webpackChunkName: "PersonalAuthBack" */ '@/views/sign/personalAuthBack.vue')
  },
  {
    path: '/personal/sign',
    name: 'PersonalSign',
    component: () => import(/* webpackChunkName: "PersonalSign" */ '@/views/sign/personalSign.vue')
  },
  {
    path: '/personal/dosign',
    name: 'PersonalDoSign',
    component: () => import(/* webpackChunkName: "PersonalDoSign" */ '@/views/sign/personalDoSign.vue')
  },
  {
    path: '/personal/tosign',
    name: 'PersonalToSign',
    component: () => import(/* webpackChunkName: "PersonalToSign" */ '@/views/sign/personalToSign.vue')
  },
  {
    path: '/personal/signMng',
    name: 'PersonalSignMng', 
    component: () => import(/* webpackChunkName: "PersonalSignMng" */ '@/views/sign/personalSignMng.vue')
  },
  {
    path: '/personal/done',
    name: 'PersonalDone',
    component: () => import(/* webpackChunkName: "PersonalDone" */ '@/views/sign/personalDone.vue')
  },
  {
    path: '/enterprise/register',
    name: 'EnterpriseRegister',
    component: () => import(/* webpackChunkName: "EnterpriseRegister" */ '@/views/sign/enterpriseRegister.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */ '@/views/login/register')
  },
  {
    path: '/registerInfo',
    name: 'RegisterInfo',
    component: () => import(/* webpackChunkName: "registerInfo" */ '@/views/login/registerInfo')
  },
  {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: () => import(/* webpackChunkName: "forgetPassword" */ '@/views/login/forgetPassword')
  },
  {
    path: '/company',
    name: 'Company',
    component: () => import(/* webpackChunkName: "Company" */ '@/views/login/company.vue')
  },
  {
    path: '/invitated',
    name: 'Invitated',
    component: () => import(/* webpackChunkName: "Invitated" */ '@/views/login/invitated.vue')
  },
  {
    path: '/404',
    name: 'ErrorPage',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404')
  },
  // 未登录时重定向至首页
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '*',
    redirect: '/home'
  }
]
export const asyncRoutes = []

const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router

// const router = new VueRouter({
//   routes,
//   scrollBehavior(to, from, savedPosition) {
//     if(savedPosition) {
//       return savedPosition
//     } else {
//       return {
//         x: 0,
//         y: 0
//       }
//     }
//   }
// })

// router.beforeEach(async (to, from, next) => {
//   const isflash = store.getters.isflash
//   if (!isflash) {
//     next()
//   } else {
//     store.commit('user/SET_FALSH', false)
//     await store.dispatch('user/getMenus')
//     if(!!store.getters.token) {
//       await store.dispatch('user/getIdentity')
//       await store.dispatch('user/getInfo')
//       let menus = await store.dispatch('user/getMenusBack')
//       let menusArr = []
//       menus.map(item => !!item.name && menusArr.push(item.name))
//       // generate accessible routes map based on roles
//       const accessRoutes = await store.dispatch('permission/generateRoutes', menusArr)
//       // dynamically add accessible routes
//       router.addRoute(accessRoutes)
//       router.history.setupListeners();
//       next({ ...to, replace: true })
//     } else {
//       if(to.path.indexOf('/back') == 0) {
//         next({ path: '/' })
//       } else {
//         next({ ...to, replace: true })
//       }
//     }
//   }
// })

// export default router
